<template>
    <div>
        <Header-dark></Header-dark>
          <router-view></router-view>
        <Footer></Footer>
    </div>
</template>


<script>
import HeaderDark from '../components/shared/HeaderDark'
import Footer from '../components/shared/Footer'

export default {
    components:{
        Footer,
        HeaderDark
    }
}
</script>